<template>
  <div class="stock-dialog">
    <el-dialog
      v-loading="true"
      :close-on-click-modal="false"
      title=""
      :append-to-body="true"
      center
      width="30%"
      :visible.sync="stockDialogVisable"
    >
      <el-form
        ref="stockDialogForm"
        :rules="stockRules"
        :model="stockDialogForm"
        status-icon
        class="stock-dialog-form"
      >
        <el-form-item label="数量" prop="change_stock_num">
          <el-input v-model="stockDialogForm.change_stock_num"></el-input>
        </el-form-item>
        <el-form-item label="待审核价格" prop="new_price">
          <el-input
            v-model="stockDialogForm.new_price"
            @change="changePrice"
            :disabled="is_deposit == '1'"
          ></el-input>
        </el-form-item>
        <span class="deposit_tips" v-if="is_deposit == '1'"
          >注：该商品为定金购商品，暂不支持改价</span
        >
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeStockDialog">取 消</el-button>
        <el-button type="primary" @click="saveStock">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateStock, updateNewPrice } from "@/models/goodsModel";
export default {
  props: ["rowData"],
  data() {
    var checkNum = (rule, value, callback) => {
      if (value === 0) {
        callback();
      } else if (!value) {
        return callback(new Error("不能为空"));
      }
      if (!/(^-?[0-9]\d*$)/.test(value)) {
        callback(new Error("请输入整数"));
      } else {
        if (value.length > 6) {
          callback(new Error("请输入6位数以内的整数"));
        } else {
          callback();
        }
      }
    };
    var checkPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }
      if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请输入正数"));
      } else {
        if (parseInt(value) < 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }
    };
    return {
      change_price: "",
      stockDialogVisable: false,
      stockDialogForm: {
        id: "",
        change_stock_num: "",
        new_price: "",
        price: "",
        ruigu_code: ""
      },
      stockRules: {
        change_stock_num: [
          { validator: checkNum, required: true, trigger: "change" }
        ],
        new_price: [
          { validator: checkPrice, required: true, trigger: "change" }
        ]
      },
      is_deposit: undefined
    };
  },
  methods: {
    closeStockDialog() {
      this.stockDialogVisable = false;
      this.$emit("updateTable");
    },
    changePrice(val) {
      this.change_price = val;
    },
    async saveStock() {
      this.$refs.stockDialogForm.validate(valid => {
        let vm = this;
        const saveStock = async () => {
          let stockParams = {
            id: vm.stockDialogForm.id,
            change_stock_num: vm.stockDialogForm.change_stock_num
          };
          let priceParams = {
            id: vm.stockDialogForm.id
          };
          priceParams.sku_code = vm.stockDialogForm.ruigu_code;
          if (vm.change_price) {
            priceParams.new_price = vm.change_price;
          }
          let changePriceStatus =
            this.rowData.new_price === vm.stockDialogForm.new_price;
          let changePriceStock =
            this.rowData.stock_num === vm.stockDialogForm.change_stock_num;
          console.log(
            changePriceStatus,
            "changePriceStatus",
            this.rowData.new_price,
            vm.stockDialogForm.new_price
          );
          console.log(changePriceStock, "changePriceStock");
          if (!changePriceStatus && changePriceStock) {
            let priceData = await updateNewPrice(priceParams);
            if (priceData.message === "Success") {
              vm.$message.success("修改成功");
              vm.stockDialogVisable = false;
            }
          }
          if (changePriceStatus && !changePriceStock) {
            let stockData = await updateStock(stockParams);
            if (stockData && stockData.message === "Success") {
              vm.$message.success("修改成功");
              vm.stockDialogVisable = false;
            }
          }
          if (!changePriceStatus && !changePriceStock) {
            let stockData = await updateStock(stockParams);
            let priceData = await updateNewPrice(priceParams);
            if (
              priceData.message === "Success" &&
              stockData &&
              stockData.message === "Success"
            ) {
              vm.$message.success("修改成功");
              vm.stockDialogVisable = false;
            }
          }
          if (changePriceStatus && changePriceStock) {
            vm.stockDialogVisable = false;
          }
          vm.$emit("updateTable");
        };
        if (valid) {
          saveStock();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 12px;
}
.deposit_tips {
  color: #f71000;
  margin-left: 120px;
  margin-top: -12px;
  position: absolute;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/stock/stock-dialog.vue